<template>
  <div class="login-wrap">
    <div class="progressive">
      <img
        v-progressive="require('@/assets/img/login_2.png')"
        :src="require('@/assets/img/login_2_mini.png')"
        class="imgs"
      />
    </div>
    <div class="ms-login">
      <div class="ms-title">百博OA系统</div>
      <el-form
        :model="ruleFormLogin"
        ref="login"
        label-width="0px"
        class="ms-content"
      >
        <el-form-item prop="username">
          <el-input
            v-model="ruleFormLogin.user_name"
            placeholder="用户名"
            @keyup.enter.native="userLoginBtn"
          >
            <el-button slot="prepend" icon="el-icon-user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="密码"
            v-model="ruleFormLogin.password"
            @keyup.enter.native="userLoginBtn"
          >
            <el-button slot="prepend" icon="el-icon-position"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="login-btn">
        <!-- <el-button size="small" :loading="logining">注册账号</el-button> -->
        <el-button
          size="small"
          type="primary"
          plain
          @click="userLoginBtn"
          :loading="logining"
          round
          style="width:120px"
          >进入系统</el-button
        >
      </div>
    </div>
    <div class="beian">
      <!-- Copyright 杭州百博电子商务有限公司 allrights reserved ICP备案：     <a href="http://www.beian.gov.cn/portal/index.do" target="_blank">浙ICP备16040228号-7</a>    -->
      Copyright 杭州百博电子商务有限公司 allrights reserved ICP备案：
      <a href="https://beian.miit.gov.cn" target="_blank"
        >浙ICP备16040228号-7</a
      >
    </div>
  </div>
</template>

<script>
// 引入工具类
import utils from "@/libs/utils";
//api
import api from "@/api";
export default {
  data() {
    return {
      logining: false, // 确定按键--加载效果
      // 用户登录
      ruleFormLogin: {
        user_name: "",
        password: "",
      },
    };
  },
  methods: {
    /**
     * 操作函数
     */
    // 用户登录
    userLoginBtn: function() {
      // console.log(this.ruleFormLogin.password)
      if (
        !this.ruleFormLogin.user_name ||
        this.ruleFormLogin.user_name === ""
      ) {
        utils.notificationInfo("提示", "请输入用户名", "warning");
        return;
      }
      if (!this.ruleFormLogin.password || this.ruleFormLogin.password === "") {
        utils.notificationInfo("提示", "请输入密码", "warning");
        return;
      }
      let paramObj = {
        user_name: this.ruleFormLogin.user_name,
        password: this.$md5(this.ruleFormLogin.password),
      };

      // 登录
      this.loginFunc(paramObj);
    },

    /**
     * api
     */
    // 登录
    /**
     * jurisdiction
     * 0  最高权限
     * 1 只读
     * 2 查看编辑
     *  */

    loginFunc(paramObj) {
      api
        .login(paramObj)
        .then(
          function(response) {
            this.logining = false;
            if (response.data.code == "0") {
              // 用户数据存储
              utils.sessionSetStore("user_name", response.data.data.user_name);
              utils.sessionSetStore("user_id", response.data.data.id);
              utils.sessionSetStore("post", response.data.data.post);
              utils.sessionSetStore(
                "jurisdiction",
                response.data.data.jurisdiction
              ); //权限
              utils.sessionSetStore(
                "department",
                response.data.data.department
              );
              utils.sessionSetStore("nickname", paramObj.user_name);
              // 部门名称
              switch (response.data.data.department) {
                case "1":
                  utils.sessionSetStore("departmentName", "人事部");
                  break;
                case "2":
                  utils.sessionSetStore("departmentName", "财务部");
                  this.getFinaSummary();
                  break;
                case "3":
                  utils.sessionSetStore("departmentName", "市场部");
                  break;
                case "4":
                  utils.sessionSetStore("departmentName", "运营部");
                  break;
                case "5":
                  utils.sessionSetStore("departmentName", "招商部");
                  break;
                case "6":
                  utils.sessionSetStore("departmentName", "总经办");
                  if (response.data.data.id == "1") this.getFinaSummary();
                  break;
                case "7":
                  utils.sessionSetStore("departmentName", "技术部");
                  this.getFinaSummary();
                  break;
              }

              // 更新state
              this.$store.commit(
                "setDepartment",
                response.data.data.department
              );
              this.$store.commit("setUserId", response.data.data.id);
              this.$store.commit("setUserName", response.data.data.user_name);

              this.$router.push({
                path: "/index/accountManagement",
              });
            } else {
              utils.notificationInfo("提示", `${response.data.msg}`, "warning");
            }
          }.bind(this)
        )
        .catch(function(err) {
          console.log(err);
          utils.notificationInfo("提示", `${err.data.msg}`, "warning");
        });
    },

    // 获取财务汇总明细 技术、财务部可获取
    getFinaSummary() {
      api.getFinancialSumOptions().then((res) => {
        // console.log(res)
        if (res.data.code == 0) {
          let sumDetailsOptions = [],
            sumDetailsOptionsTwo = [],
            result = res.data.data.list,
            dep = new Set();
          result.forEach((item) => {
            dep.add(item.label_name);
          });
          dep.forEach((item) => {
            let a1 = [],
              a2 = [];
            result.forEach((eo) => {
              if (eo.label_name === item && eo.detailed_type == 1) {
                a1.push({
                  label: eo.detailed_name,
                  value: eo.detailed_num,
                });
              }
              if (eo.label_name === item && eo.detailed_type == 2) {
                a2.push({
                  label: eo.detailed_name,
                  value: eo.detailed_num,
                });
              }
            });
            sumDetailsOptions.push({
              label: item,
              options: a1,
            });
            sumDetailsOptionsTwo.push({
              label: item,
              options: a2,
            });
          });
          utils.sessionSetStore("s", sumDetailsOptions);
          utils.sessionSetStore("st", sumDetailsOptionsTwo);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
// new
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  // background-image: url(../assets/img/login_2.png);
  // background-size: cover;
  // background-repeat: no-repeat;
  overflow: hidden;
  .progressive {
    min-width: 1300px;
    .imgs {
      width: 100%;
      height: 100%;
    }
  }

  .beian {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
    color: #fff;
    font-size: 15px;
    > a {
      color: #fff;
      font-size: 15px;
    }
  }
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
  letter-spacing: 2px;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  margin: -190px 0 0 -190px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px 0;
}
.login-btn {
  text-align: center;
  padding: 10px 0;
  margin-bottom: 10px;
  button {
    width: 90px;
  }
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
